import styled, { css } from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { BADGE_TONES } from './Badge.constants';
import { TBadgeSize, TBadgeTone, TBadgeVariant } from './Badge.types';

export const StyledBadge = styled.span.withConfig({ shouldForwardProp })<{
  $tone: TBadgeTone;
  $variant: TBadgeVariant;
  $size: TBadgeSize;
}>`
  display: inline-flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.pill}px;
  font-weight: 600;

  ${({ $variant, $tone, $size, theme }) =>
    $variant === 'soft'
      ? css`
          padding: 2px ${theme.spacing.s}px;
          font-family: ${theme.fonts.semiBold};
          font-size: ${theme.fontSizes.xs}px;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          color: ${BADGE_TONES[$tone].softFg};
          background-color: ${BADGE_TONES[$tone].softBg};
        `
      : css`
          padding: ${$size === 'sm' ? '1px 8px' : '2px 10px'};
          font-size: ${$size === 'sm' ? theme.fontSizes.xs : theme.fontSizes.s}px;
          color: ${theme.colors.onPrimary};
          background-color: ${BADGE_TONES[$tone].solid};
        `}
`;
